<template>

        <!-- 固定工具栏 -->
        <div class="format-toolbar">
          <a-button-group>
            <a-button @click="formatText.bold" title="粗体">B</a-button>
            <a-button @click="formatText.italic" title="斜体">I</a-button>
            <a-button @click="formatText.underline" title="下划线">U</a-button>
            <a-button @click="formatText.strikethrough" title="删除线">S</a-button>
            <a-button @click="formatText.code" title="行内代码">{}</a-button>
            <a-button @click="formatText.codeblock" title="代码块">{ }</a-button>
            <a-button @click="formatText.link" title="添加链接">🔗</a-button>
            <a-button @click="formatText.spoiler" title="隐藏文本">��</a-button>
            <a-button @click="formatText.quote" title="引用">"</a-button>
          </a-button-group>
        </div>

    <div class="text">
      <textarea placeholder="按 Ctrl + Enter 发送" v-model="content" @keyup="onKeyup"></textarea>
      <div  class="button-container">
        <a-button type="primary" style="width: 100px;" @click="handleSendPostMan">POSTMAN</a-button>
        <a-button type="primary" style="width: 100px;" @click="handleSendMsg">发送</a-button>
        <!-- <input type="file" accept="image/*" style="width: 150px;" @change="handleFileUpload"> -->
      </div>

    </div>

    <!-- 链接编辑对话框 -->
    <a-modal
      v-model:visible="linkModalVisible"
      title="添加链接"
      @ok="handleLinkConfirm"
      okText="确定"
      cancelText="取消"
    >
      <a-form :model="linkForm" layout="vertical">
        <a-form-item label="链接文字">
          <a-input v-model:value="linkForm.text" placeholder="请输入链接显示的文字" />
        </a-form-item>
        <a-form-item label="链接地址">
          <a-input v-model:value="linkForm.url" placeholder="请输入链接地址" />
        </a-form-item>
      </a-form>
    </a-modal>

    
  </template>
  
  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import { computed,onMounted,ref,watch,reactive } from 'vue';
  import { TelegramClient } from "@/websocket/Client";
  import { message } from "ant-design-vue";
  const store = useStore();
  const content = ref('');
  const client = TelegramClient.getInstance();
  const onKeyup = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.keyCode === 13 && content.value.length) {
      store.commit('SEND_MESSAGE', content.value);
      content.value = '';
    }
  };

// 添加链接编辑对话框的状态
const linkModalVisible = ref(false)
const linkForm = reactive({
  text: '',
  url: ''
})

// const formState = reactive({
//   message: "",
// });

// 修改格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    // 处理多行引用
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    console.log("link");
    const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    // 保存当前光标位置
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    // 显示链接编辑对话框
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  content.value = text.substring(0, start) + newText + text.substring(end);
  
  // 恢复焦点并更新光标位置
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.text textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
  console.log("dadf");
};

 

  // WebSocket 消息监听
  onMounted(() => {
    //refreshReceiverList();

  });

 

  const currentId = computed<number>(() => store.state.currentSessionId);

 
 const handleSendPostMan = async() => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(content.value == "")
    {
      message.error(`发送失败: 发送内容为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    var msg = "[POSTMAN]" + content.value;
    const result = await client.sendMessage(
      account,
      name,
      targets,
      content.value,
      2
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', msg);
      content.value = '';
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };

 
  
  const handleFileUpload =(event) => {
      const file = event.target.files[0];

      if (file) {
         convertToBase64(file);
      }
    }


    const convertToBase64 =(file)=> {
      const reader = new FileReader();

      reader.onload = (e) => {
        var base64Image = e.target.result; // Set the base64 data
        //store.commit('SEND_MESSAGE', base64Image);
        handleSendImageMsg(base64Image);
        console.log("onload="+base64Image);
      };

      reader.onerror = (error) => {
        console.log('Error: ', error); // Handle errors
      };

      reader.readAsDataURL(file); // Read the file as a data URL
    }
 


    const handleSendImageMsg = async(base64Image) => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(base64Image == "")
    {
      message.error(`发送失败: base64Image为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    const result = await client.sendMessage(
      account,
      name,
      targets,
      base64Image,
      1
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', base64Image);
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };



  const handleSendMsg = async() => {
    var chatTarget = store.state.currentSessionId;
    console.log("handleSendMsg2="+chatTarget);
    if(content.value == "")
    {
      message.error(`发送失败: 发送内容为空`);
      return;
    }
    const account = localStorage.getItem("username") || "";
    var name = store.state.user.name;
    var chatTarget = store.state.currentSessionId;
    var targets = [{Id:chatTarget}];
    const result = await client.sendMessage(
      account,
      name,
      targets,
      content.value,
      1
    );

    if (result && result.code === 1) {
      store.commit('SEND_MESSAGE', content.value);
      content.value = '';
    } else {
      const errorMsg = result?.reason || "发送失败";
      message.error(`发送失败: ${errorMsg}`);
    }
 
  };


  </script>
  
  <style lang="less" scoped>
  .text {
    height: 160px;
    border-top: solid 1px #ddd;
    display: flex;
    textarea {
      padding: 10px;
      height: 100%;
      width: 90%;
      border: none;
      outline: none;
      font-family: "Micrsofot Yahei";
      resize: none;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column; /* 设置垂直排列 */
    gap: 16px; /* 设置按钮之间的距离 */
  }

  </style>